import React from 'react';
import './Carousel.css';
import fertilizer from '../assets/fertilizer.png';
import digister from '../assets/digister.png';
import tanker1 from '../assets/tanker1.png';
import fertilizer1 from '../assets/fertilizer1.png'

const Carousel = () => {
  return (
    <div className="carousel-wrapper">
      <div id="mainCarousel" className="carousel slide" data-bs-ride="carousel" data-bs-interval="2000">
        <div className="carousel-indicators">
          <button type="button" data-bs-target="#mainCarousel" data-bs-slide-to="0" className="active" aria-current="true" aria-label="Slide 1"></button>
          <button type="button" data-bs-target="#mainCarousel" data-bs-slide-to="1" aria-label="Slide 2"></button>
          <button type="button" data-bs-target="#mainCarousel" data-bs-slide-to="2" aria-label="Slide 3"></button>
        </div>
        <div className="carousel-inner">
          <div className="carousel-item active">
            <img src={fertilizer} className="d-block w-100" alt="Fertilizer" />
            <div className="carousel-caption text-start">
              <h1 className="display-5 fw-bold mb-3">From Waste to Watt – Empowering Green Energy</h1>
              <p className="lead mb-4">Transforming Bio degradable waste into safe, low-pressure CBG and bio-fertilizer solutions for industries and MSMEs.</p>
              <div className="d-flex gap-3">
                <a href="#contact" className="btn btn-primary btn-lg">Get Green Energy Today</a>
                <a href="#about" className="btn btn-outline-secondary btn-lg ">Learn More</a>
              </div>
            </div>
          </div>
          <div className="carousel-item">
            <img src={digister} className="d-block w-100" alt="Digister" />
            <div className="carousel-caption text-start">
              <h1 className="display-5 fw-bold mb-3">Patented Low-Pressure CBG Distribution</h1>
              <p className="lead mb-4">SMPV‑approved 14‑bar mobile vessels supply 0.5–1 bar directly—cut capex and losses.</p>
              <div className="d-flex gap-3">
                <a href="#products" className="btn btn-primary btn-lg">Our Solutions</a>
                <a href="#contact" className="btn btn-outline-secondary btn-lg">Contact Us</a>
              </div>
            </div>
          </div>
          <div className="carousel-item">
            <img src={fertilizer1} className="d-block w-100" alt="tanker1" />
            <div className="carousel-caption text-start">
              <h1 className="display-5 fw-bold mb-3">Made‑in‑India Waste‑to‑Energy</h1>
              <p className="lead mb-4">Turning food and agri waste into clean fuel, organics, and CO₂‑derived products.</p>
              <div className="d-flex gap-3">
                <a href="#contact" className="btn btn-primary btn-lg">Invest in Green Energy</a>
                <a href="#contact" className="btn btn-outline-secondary btn-lg">Partner with Us</a>
              </div>
            </div>
          </div>
        </div>
        <button className="carousel-control-prev" type="button" data-bs-target="#mainCarousel" data-bs-slide="prev">
          <span className="carousel-control-prev-icon" aria-hidden="true"></span>
          <span className="visually-hidden">Previous</span>
        </button>
        <button className="carousel-control-next" type="button" data-bs-target="#mainCarousel" data-bs-slide="next">
          <span className="carousel-control-next-icon" aria-hidden="true"></span>
          <span className="visually-hidden">Next</span>
        </button>
      </div>
    </div>
  );
};

export default Carousel;
